export default __webpack_public_path__ + "static/media/airplane_icon.25d57ecf.svg";